<template>
	<div>

		<div v-if="loading">
			Loading ...
		</div>
		<div v-else-if="!autoload && !Object.keys(data).length">
			<button v-on:click="load">Load</button>
		</div>
		<div v-else>
			<div class="flex">
				<div class="flex-basis" v-for="(shipment, s) in data" v-if="s == 'outbound' || s == 'return'">
					<div class="flex margin-bottom">
						<h2 style="margin: 0">{{ s.substr(0, 1).toUpperCase() + s.substr(1) }}</h2>
						<div class="margin-left">
							<button class="small" v-on:click="refresh(shipment)" :disabled="saving">Refresh</button>
							<button class="small small-margin-left" v-on:click="editing = editing == shipment.id ? false : shipment.id">
								Edit
							</button>
							<button
								class="small small-margin-left"
								:disabled="saving"
								v-on:click="lost(shipment)"
								v-if="!data.lost[s]">Report as lost</button>
						</div>
					</div>
					<div v-if="editing == shipment.id" class="margin-bottom margin-top">
						<MaterialText
							class="small-margin-bottom"
							:disabled="saving"
							v-model="shipment.tracking.number"
							label="Tracking number"
							v-on:enter="update(shipment)" />
						<MaterialText
							:disabled="saving"
							v-model="shipment.tracking.url"
							label="URL"
							v-on:enter="update(shipment)" />
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">ID</div>
						<div>{{ shipment.id }}</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">Company</div>
						<div>{{ shipment.shipping_company.name }}</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">Last updated</div>
						<div>
							<Format type="date" :time="true" :value="shipment.last_updated_at" />
						</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">Tracking no.</div>
						<div>{{ shipment.tracking.number }}</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">URL</div>
						<div>
							<a target="_blank" :href="shipment.tracking.url">{{ shipment.tracking.url }}</a>
						</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">Status</div>
						<div>{{ getStatusText(shipment) }}</div>
					</div>
					<div class="input-row xs-margin-bottom">
						<div class="label">Timeline</div>
						<div>
							<div v-for="(date, d) in shipment.dates" v-if="date" v-bind:class="{
								'xs-margin-bottom': !! d,
							}">
								<div class="note">{{ getTimelineTitle(d) }}</div>
								<Format type="date" :time="true" :value="date" />
							</div>
						</div>
					</div>

					<div v-if="data.lost[s]">
						<h3>Lost</h3>
						<div class="input-row xs-margin-bottom">
							<div class="label">Created</div>
							<div>
								<Format type="date" :time="true" :value="data.lost[s].created_at" />
							</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Resolved</div>
							<div>
								<Format type="date" :time="true" :value="data.lost[s].resolved_at" />
							</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Status</div>
							<div>{{ data.lost[s].status }}</div>
						</div>

						<div class="margin-top" v-if="!data.lost[s].resolved_at">
							<button class="small-margin-right" :disabled="saving" v-on:click="resolved(shipment)">Resolved</button>
							<select :disabled="saving" v-on:change="saveLostShipment(data.lost[s])" v-model="data.lost[s].status">
								<option value="">[ None ]</option>
								<option :value="status" v-for="status in data.lost_statuses">{{ status }}</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<div class="margin-top" v-if="data.order_status">
				<strong>Order status</strong>
				<br />
				{{ getOrderStatus(data.order_status) }}
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id',
    'autoload'
  ],
  data: () => ({
    data: {},
    loading: false,
    saving: false,
    editing: false
  }),
  methods: {
    update (tracking) {
      Vue.$api.put('/tracking/' + tracking.id, {
        tracking_number: tracking.tracking.number,
        url: tracking.tracking.url
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => this.editing = false
      })
    },
    saveLostShipment (lost) {
      Vue.$api.patch('/lost-shipment/' + lost.id, lost, {
        loader: toggle => this.saving = toggle
      })
    },
    resolved (shipment) {
      Vue.$api.post('/tracking/' + shipment.id + '/resolve', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    lost (shipment) {
      Vue.$api.post('/tracking/' + shipment.id + '/lost', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    refresh (shipment) {
      Vue.$api.post('/tracking/' + shipment.id + '/refresh', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/order/' + this.id + '/tracking', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.data = data
      })
    },
    getOrderStatus (status) {
      switch (status) {
        default:
          return status
      }
    },
    getTimelineTitle (key) {
      switch (key) {
        case 'parcelshop_at':
          return 'Parcelshop'
        case 'label_at':
          return 'Label created'
        case 'parcel_center_at':
          return 'Sorting (parcel center)'
        case 'returned_to_sender_at':
          return 'Returned to sender'
        case 'delivered_at':
          return 'Delivered at'
        case 'picked_up_at':
          return 'Picked up at'
        default:
          return key
      }
    },
    getStatusText (shipment) {
      switch (shipment.status) {
        case 'returned-to-sender':
          return 'Returned to sender'
        case 'parcelshop':
          return 'At the parcelshop'
        case 'label-created':
          return 'Label created'
        default:
          if (!shipment.status) {
            return 'N/A'
          }

          return shipment.status.substr(0, 1).toUpperCase() + shipment.status.substr(1)
      }
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
